import React, { Component } from "react";
import "../../../../../Assets/EnsembleStyles/TitleBar.css";
import { IconButton, Tooltip } from "@mui/material";
import { PlayIcon } from "../../../ReportsManagement/ManageReports";

import { Navbar } from "reactstrap";
import { setAmplitudeEvent } from "amplitude/amplitude";
const windowFeatures =
  "resizable=1,status=yes,scrollbars=0,toolbar=0,titlebar=0,location=no,width=800,height=650,dialog=1,minimizable=1";
const windowName = "EnsembleVideoWindow";
const videoUrl =
  "https://vimeo.com/718043707/6ae6e7fe2d?share=copy&childpage=true";
export default class Titlebar extends Component {
  render() {
    return (
      <div
        className="title_Bar"
        style={
          this.props.istabView
            ? {
                "border-bottom": "0px",
                display: "flex",
                justifyContent: "space-between",
              }
            : {}
        }
      >
        <Navbar expand="md">
          <h4 className="page_title" style={{ textAlign: "left" }}>
            {this.props.parentToChildData}
          </h4>
        </Navbar>{" "}
        {this.props.parentToChildData === "Tenant Services" ? (
          <Tooltip title="Introduction to Tenant Services">
          <IconButton
            id="tenantServiceVideoIconButton"
            style={{ textAlign: "right" , alignItems: "center", margin:"20px 20px 0px 0px"}}
            onClick={() => {window.open(videoUrl, windowName, windowFeatures);
              setAmplitudeEvent('Help Videos', {
                "Source": "Icon",
                "Video Name": "Introduction to Tenant Services",
                "Page URL": '/React/Home.aspx?Page=tenant#/managetenant'})
  
            }}
          >
            <PlayIcon style={{width:'25px', height:'25px'}}/>
          </IconButton>
        </Tooltip>) : null}
        
      </div>
    );
  }
}
